import React from "react";
import {NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import {useLocationFormState} from "../../components/buyerUser/BuyerUserForm/BuyerUserAddForm";
import BuyerUserAddFormProvider from "../../components/buyerUser/BuyerUserForm/BuyerUserAddFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const BuyerUserAddEditPage = () => {

    useTitle(t`Add Buyer User`);

    return (
        <Box data-testid="BuyerUser-add-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="BuyerUser-add-title"
                    >
                        <Trans>Add Buyer User</Trans>
                    </Typography>
                    <BuyerUserAddFormProvider
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default BuyerUserAddEditPage;
